if (!customElements.get('gift-box-addon')) {
  customElements.define(
    'gift-box-addon',
    class GiftBoxAddon extends HTMLElement {
      async connectedCallback() {
        // This script runs before the pickup/gallery scripts on the product page.
        // A variant change calls their methods, so wait until they are upgraded.
        const dependencies = ['variant-selects', 'product-form'];
        if (document.querySelector('pickup-availability')) dependencies.push('pickup-availability');
        if (document.querySelector(`[id^="MediaGallery-${this.dataset.section}"]`)) {
          dependencies.push('media-gallery');
        }
        await Promise.all(dependencies.map((name) => customElements.whenDefined(name)));
        if (!this.isConnected || this.initialized) return;
        this.initialized = true;
        this.checkbox = this.querySelector('.gift-box-addon__checkbox');
        this.picker = this.querySelector('variant-selects');
        this.variants = JSON.parse(this.picker.querySelector('[type="application/json"]').textContent);
        this.onChange = () => this.selectVariant();
        this.checkbox.addEventListener('change', this.onChange);
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
          if (data.sectionId !== this.dataset.section) return;
          // The existing sticky cart uses the main form; keep its price in sync too.
          const stickyPrice = document.querySelector('#StickyATC .sticky-atc__price');
          const price = data.html.getElementById(`price-${this.dataset.section}`);
          if (stickyPrice && price) stickyPrice.innerHTML = price.innerHTML;
        });
        // Always start without the add-on, even when arriving via a variant URL.
        this.checkbox.checked = false;
        const form = document.getElementById(`product-form-${this.dataset.section}`);
        const selectedVariantId = form?.querySelector('input[name="id"]')?.value;
        // The server already rendered the correct price and availability for the
        // usual default selection. Avoid disabling a ready form just to refetch it.
        if (selectedVariantId !== this.dataset.withoutVariant) this.selectVariant();
        this.checkbox.disabled = false;
      }

      disconnectedCallback() {
        this.checkbox?.removeEventListener('change', this.onChange);
        this.unsubscribe?.();
        this.initialized = false;
      }

      selectVariant() {
        const variantId = this.checkbox.checked ? this.dataset.withVariant : this.dataset.withoutVariant;
        const variant = this.variants.find((item) => String(item.id) === variantId);
        if (!variant) return;

        // Drive the theme's own picker so price, inventory, media and cart IDs
        // follow the same path as an ordinary variant selection.
        const options = this.picker.querySelectorAll('select, fieldset');
        let changedInput;
        options.forEach((option, index) => {
          if (option.tagName === 'SELECT') {
            option.value = variant.options[index];
            changedInput = option;
          } else {
            option.querySelectorAll('input[type="radio"]').forEach((input) => {
              input.checked = input.value === variant.options[index];
              if (input.checked) changedInput = input;
            });
          }
        });
        changedInput?.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  );
}
